// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chakra-tabs__tab-panel {
  padding: 10px 0 !important;
}

#info .title,
#info .subtitle {
  color: #414141;
  font-size: 13.4px;
  padding-bottom: 12px;
}
#info .title {
  font-weight: 600;
}
#info .subtitle {
  padding-left: 12px;
}

#orts {
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
}
#orts thead {
  color: white;
  background-color: #9cd1f2;
}
#orts th,
#orts td {
  font-size: 13px;
  font-weight: 400;
  border: 1px solid #dddddd;
  border-collapse: collapse;
  padding: 5px 12px;
  text-align: center;
}

.tech-card {
  flex: 0 0 49%;
  font-size: 13px;
  border: 1px solid #dddddd;
}
@media (max-width: 768px) {
  .tech-card {
    flex: 0 0 100%;
  }
}
.tech-card .title {
  color: white;
  background-color: #9cd1f2;
  padding: 5px 20px;
}
.tech-card .description {
  padding: 15px 20px;
  line-height: 1.7rem;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/views/admin/food/style.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;;AAGE;;EAEE,cAAA;EACA,iBAAA;EACA,oBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,kBAAA;AAFJ;;AAMA;EACE,WAAA;EACA,uBAAA;EACA,yBAAA;AAHF;AAKE;EACE,YAAA;EACA,yBAAA;AAHJ;AAME;;EAEE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,iBAAA;EACA,kBAAA;AALJ;;AASA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;AANF;AAQE;EALF;IAMI,cAAA;EALF;AACF;AAOE;EACE,YAAA;EACA,yBAAA;EACA,iBAAA;AALJ;AAQE;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AANJ","sourcesContent":[".chakra-tabs__tab-panel {\r\n  padding: 10px 0 !important;\r\n}\r\n\r\n#info {\r\n  .title,\r\n  .subtitle {\r\n    color: #414141;\r\n    font-size: 13.4px;\r\n    padding-bottom: 12px;\r\n  }\r\n\r\n  .title {\r\n    font-weight: 600;\r\n  }\r\n\r\n  .subtitle {\r\n    padding-left: 12px;\r\n  }\r\n}\r\n\r\n#orts {\r\n  width: 100%;\r\n  border: 1px solid black;\r\n  border-collapse: collapse;\r\n\r\n  thead {\r\n    color: white;\r\n    background-color: #9cd1f2;\r\n  }\r\n\r\n  th,\r\n  td {\r\n    font-size: 13px;\r\n    font-weight: 400;\r\n    border: 1px solid #dddddd;\r\n    border-collapse: collapse;\r\n\r\n    padding: 5px 12px;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.tech-card {\r\n  flex: 0 0 49%;\r\n  font-size: 13px;\r\n  border: 1px solid #dddddd;\r\n\r\n  @media (max-width: 768px) {\r\n    flex: 0 0 100%;\r\n  }\r\n\r\n  .title {\r\n    color: white;\r\n    background-color: #9cd1f2;\r\n    padding: 5px 20px;\r\n  }\r\n\r\n  .description {\r\n    padding: 15px 20px;\r\n    line-height: 1.7rem;\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
